import { useCookies } from 'react-cookie';

/**
 * Checks if the current user is identified as a Datadog Synthetics user
 * via the 'dd_synthetics' cookie.
 *
 * @returns {boolean} True if the 'dd_synthetics' cookie is present and set to true, false otherwise.
 */
export function useIsSyntheticsUser() {
    const [cookies] = useCookies(['dd_synthetics']);
    return cookies.dd_synthetics === true;
}
